var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"dashboard"}},[_c('main',[(_vm.presentation == _vm.tableKey)?_c('data-table',{attrs:{"id":"dataTable"}}):_c('chart',{attrs:{"id":"chart"}})],1),_c('aside',[_c('controls')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }